"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const uris = require("../globals/uris");
const rendering_1 = require("../model/rendering");
const uicontrol_1 = require("../controls/uicontrol");
const datacontrol_1 = require("../controls/datacontrol");
const sensorcontrol_1 = require("../controls/sensorcontrol");
const randomcontrol_1 = require("../controls/auto/randomcontrol");
const browniancontrol_1 = require("../controls/auto/browniancontrol");
const rampcontrol_1 = require("../controls/auto/rampcontrol");
const fetcher_1 = require("../util/fetcher");
/**
 * A DymoLoader loads dymos from rdf, jams, or json-ld into the given DymoStore
 * and creates the necessary controls, constraints, and renderings
 */
class DymoLoader {
    constructor(dymoStore, fetcher = new fetcher_1.FetchFetcher()) {
        this.fetcher = fetcher;
        this.controls = new Map(); //dict with all the controls created
        this.renderings = new Map();
        this.currentBasePath = '';
        this.store = dymoStore;
        this.resetLatestLoadedStuff();
    }
    loadFromFiles(...fileUris) {
        return this.loadIntoStore(...fileUris)
            .then(() => this.loadFromStore());
    }
    loadFromString(string) {
        return this.store.loadData(string)
            .then(() => this.loadFromStore());
    }
    loadIntoStore(...fileUris) {
        //TODO now simply takes path of first file as reference, CHANGE!!
        const shouldLoad = fileUris.length > 0;
        if (shouldLoad) {
            this.currentBasePath = fileUris[0].substring(0, fileUris[0].lastIndexOf('/') + 1);
            return Promise.all(fileUris.map(f => this.fetcher.fetchText(f)
                .then(jsonld => this.store.loadData(jsonld))));
        }
        else {
            return Promise.resolve();
        }
    }
    resetLatestLoadedStuff() {
        let latest = this.latestLoadedStuff;
        this.latestLoadedStuff = { dymoUris: [], rendering: null, controls: [], constraintUris: [] };
        return latest;
    }
    addLatestLoadedStuff(type, stuff) {
        this.latestLoadedStuff[type] = _.uniq(this.latestLoadedStuff[type].concat(stuff));
    }
    loadFromStore(...objectUris) {
        return __awaiter(this, void 0, void 0, function* () {
            let controlUris = [], dymoUris, renderingUri, constraintUris = [], navigatorUris = [];
            if (objectUris.length > 0) {
                let types = yield Promise.all(objectUris.map(u => this.store.findObject(u, uris.TYPE)));
                dymoUris = objectUris.filter((u, i) => types[i] === uris.DYMO);
                renderingUri = objectUris.filter((u, i) => types[i] === uris.RENDERING);
                let isControlType = yield Promise.all(types.map(t => this.store.isSubclassOf(t, uris.MOBILE_CONTROL)));
                controlUris = objectUris.filter((u, i) => isControlType[i]);
                constraintUris = objectUris.filter((u, i) => types[i] === uris.FOR_ALL); //that's what constraints are currently
            }
            else {
                dymoUris = yield this.store.findTopDymos();
                renderingUri = yield this.store.findSubject(uris.TYPE, uris.RENDERING);
            }
            this.addLatestLoadedStuff("dymoUris", yield this.loadDymos(...dymoUris));
            this.addLatestLoadedStuff("controls", yield this.loadControls(...controlUris));
            if (renderingUri) {
                this.latestLoadedStuff.rendering = yield this.loadRendering(renderingUri);
            }
            this.addLatestLoadedStuff("constraintUris", yield this.store.activateNewConstraints(constraintUris));
            return this.resetLatestLoadedStuff();
        });
    }
    loadDymos(...dymoUris) {
        return __awaiter(this, void 0, void 0, function* () {
            var loadedDymos = [];
            yield Promise.all(dymoUris.map((u) => __awaiter(this, void 0, void 0, function* () {
                this.store.addBasePath(u, this.currentBasePath);
                //create all dymo constraints
                this.addLatestLoadedStuff("constraintUris", yield this.activateConstraintsOfOwner(u));
            })));
            return dymoUris;
        });
    }
    loadRendering(renderingUri) {
        return __awaiter(this, void 0, void 0, function* () {
            var dymoUri = yield this.store.findObject(renderingUri, uris.HAS_DYMO);
            if (renderingUri && !this.renderings.has(renderingUri)) {
                var rendering = new rendering_1.Rendering(dymoUri);
                this.addLatestLoadedStuff("controls", yield this.createControls());
                this.addLatestLoadedStuff("constraintUris", yield this.activateConstraintsOfOwner(renderingUri));
                this.loadNavigators(renderingUri, rendering);
                this.renderings.set(renderingUri, rendering);
            }
            return this.renderings.get(renderingUri);
        });
    }
    activateConstraintsOfOwner(ownerUri) {
        return __awaiter(this, void 0, void 0, function* () {
            let constraints = yield this.store.findAllObjects(ownerUri, uris.CONSTRAINT);
            return this.store.activateNewConstraints(constraints);
        });
    }
    loadNavigators(renderingUri, rendering) {
        return __awaiter(this, void 0, void 0, function* () {
            var navigators = yield this.store.findAllObjects(renderingUri, uris.HAS_NAVIGATOR);
            for (var i = 0; i < navigators.length; i++) {
                //var variable = new ConstraintLoader(this.store).loadVariable(await this.store.findObject(navigators[i], uris.NAV_DYMOS));
                //rendering.addSubsetNavigator(variable, this.getNavigator(this.store.findObject(navigators[i], uris.TYPE)));
            }
        });
    }
    createControls() {
        return __awaiter(this, void 0, void 0, function* () {
            var controlClasses = yield this.store.recursiveFindAllSubClasses(uris.MOBILE_CONTROL);
            var controlUris = _.flatten(yield Promise.all(controlClasses.map(c => this.store.findSubjects(uris.TYPE, c))));
            return this.loadControls(...controlUris);
        });
    }
    loadControls(...controlUris) {
        return __awaiter(this, void 0, void 0, function* () {
            let unloadedControls = _.difference(controlUris, [...this.controls.keys()]);
            yield Promise.all(unloadedControls.map((u) => __awaiter(this, void 0, void 0, function* () {
                var currentName = yield this.store.findObjectValue(u, uris.NAME);
                currentName = currentName ? currentName : u;
                var controlType = yield this.store.findObject(u, uris.TYPE);
                this.controls.set(u, yield this.getControl(u, currentName, controlType));
            })));
            return controlUris.map(u => this.controls.get(u));
        });
    }
    getControl(uri, name, type) {
        return __awaiter(this, void 0, void 0, function* () {
            var control;
            if (type == uris.ACCELEROMETER_X || type == uris.ACCELEROMETER_Y || type == uris.ACCELEROMETER_Z
                || type == uris.TILT_X || type == uris.TILT_Y
                || type == uris.GEOLOCATION_LATITUDE || type == uris.GEOLOCATION_LONGITUDE
                || type == uris.GEOLOCATION_DISTANCE || type == uris.COMPASS_HEADING) {
                control = new sensorcontrol_1.SensorControl(uri, type, this.store);
            } /* else if (type == uris.BEACON) {
              var uuid = this.store.findObjectValue(uri, uris.HAS_UUID);
              var major = this.store.findObjectValue(uri, uris.HAS_MAJOR);
              var minor = this.store.findObjectValue(uri, uris.HAS_MINOR);
              control = new BeaconControl(uuid, major, minor, this.store);
            }*/
            else if (type == uris.SLIDER || type == uris.TOGGLE || type == uris.BUTTON || type == uris.CUSTOM_CONTROL) {
                control = new uicontrol_1.UIControl(uri, name, type, this.store);
                var init = yield this.store.findObjectValue(uri, uris.VALUE);
                //control.value = init;
                //control.update();
                control.updateValue(init);
            }
            else if (type == uris.RANDOM) {
                control = new randomcontrol_1.RandomControl(uri, this.store);
            }
            else if (type == uris.BROWNIAN) {
                var init = yield this.store.findObjectValue(uri, uris.VALUE);
                control = new browniancontrol_1.BrownianControl(uri, this.store, init);
            }
            else if (type == uris.RAMP) {
                var milisDuration = Math.round((yield this.store.findObjectValue(uri, uris.HAS_DURATION)) * 1000);
                var init = yield this.store.findObjectValue(uri, uris.VALUE);
                control = new rampcontrol_1.RampControl(uri, milisDuration, this.store, init);
            }
            else if (type == uris.DATA_CONTROL) {
                var url = yield this.store.findObjectValue(uri, uris.HAS_URL);
                var jsonMapString = String(yield this.store.findObjectValue(uri, uris.HAS_JSON_MAP));
                var jsonMap = new Function("json", jsonMapString);
                control = new datacontrol_1.DataControl(uri, url, jsonMap, this.store, this.fetcher);
            }
            //TODO implement in better way (only works for sensor controls)
            if ((yield this.store.findObjectValue(uri, uris.IS_SMOOTH)) && control.setSmooth) {
                control.setSmooth(true);
            }
            var average = yield this.store.findObjectValue(uri, uris.IS_AVERAGE_OF);
            if (!isNaN(Number(average)) && control.setAverageOf) {
                control.setAverageOf(average);
            }
            return control;
        });
    }
}
exports.DymoLoader = DymoLoader;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/io/dymoloader.js
// module id = 1303
// module chunks = 3